module.exports = __webpack_public_path__ + "static/WIIBPhone2-69e91aa2541ae8c210690c13495f1c53.svg";